import { useMemo } from "react";

const roundAmount = (amount) => {
  if (!amount) return "";

  let temp = amount;

  if (typeof amount !== "number") temp = parseInt(amount);

  return Math.round(temp).toLocaleString("id-ID");
};

const DaftarPersonalCommission = ({ data }) => {
  const DPC = useMemo(() => {
    const payee = data?.management_fee_invoice;

    const dpc = payee?.gcc_details?.map((dpc) => {
      return {
        idUser: dpc?.user?.id,
        namaMarketing: dpc?.user?.full_name,
        personalCommission: `Rp ${roundAmount(dpc?.amount)}`,
      };
    });

    let result = {
      jumlahMarketing: payee?.gcc_details?.length || 0,
      marketing: dpc,
    };

    return result;
  }, [data]);

  return (
    <div className="px-6 pt-6 mt-6 border-t border-dashed border-[#D8D8D9] pb-2">
      <p className="text-[17px] leading-[26.6px] tracking-[-0.4px] font-semibold">
        Daftar Gross Closed Commission
      </p>
      <p className="mb-2 text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
        Jumlah Marketing:{" "}
        <span className="text-[#252526]">{DPC.jumlahMarketing}</span>
      </p>

      <div>
        <div className="grid grid-cols-[80px_1fr_1fr] px-4 py-2 bg-[#F5F5F5]">
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            ID User
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            Nama Marketing
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285] text-end">
            Gross Closed Commission
          </p>
        </div>
        {!!DPC?.marketing?.length &&
          DPC.marketing.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-[80px_1fr_1fr] px-4 py-2 border-b-[0.5px] border-solid border-[#D8D8D9] last:border-none"
            >
              <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
                {item.idUser}
              </p>
              <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
                {item.namaMarketing}
              </p>
              <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526] text-end">
                {item.personalCommission}
              </p>
            </div>
          ))}
      </div>
    </div>
  );
};

export default DaftarPersonalCommission;
